module.exports = __webpack_public_path__ + "static/logo-placeholder-d5d8140fcf89a856ed050ef65c202988.png";